<template>
  <VApp>
    <VMain>
      <router-view />
    </VMain>
  </VApp>
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";

// import "./polyfills/TextEncoder";
</script>
